import Swal from 'sweetalert2';
import { taskErrorCode } from '../../services/TaskTrackingService';
import { shortName } from './taskUi';

const escapeHtml = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

/** Before closing a form with changes in it. Resolves true to throw them away. */
export const confirmDiscard = async (title) =>
    (
        await Swal.fire({
            title,
            text: "What you've changed won't be saved.",
            showCancelButton: true,
            confirmButtonText: 'Discard',
            cancelButtonText: 'Keep editing',
        })
    ).isConfirmed;

/**
 * Runs a task request; if the server answers that some assignees can't open the file yet,
 * asks the PM to confirm giving them edit access and retries with grantContentAccess.
 * Resolves with the response, or null if the PM declined.
 */
export const withAccessConfirmation = async (request) => {
    try {
        return await request(false);
    } catch (error) {
        if (taskErrorCode(error) !== 'ACCESS_CONFIRMATION_REQUIRED') {
            throw error;
        }
        const needed = error.response.data.accessNeeded || [];
        const languages = error.response.data.languageNeeded || [];
        const list = needed
            .map((n) => `<li><b>${escapeHtml(shortName(n.user))}</b> (${escapeHtml(n.user)}): ${escapeHtml(n.title || n.contentId)}</li>`)
            .join('');
        const languageList = languages
            .map((n) => `<li><b>${escapeHtml(shortName(n.user))}</b>: ${escapeHtml(n.language)}</li>`)
            .join('');
        const accessHtml = needed.length
            ? `<p style="text-align:left">These people can't open the file yet:</p>` +
              `<ul style="text-align:left">${list}</ul>` +
              `<p style="text-align:left">Giving access lets them edit everything in the folder that holds the file.</p>`
            : '';
        // Only a PM can change a profile, so this part is for reading
        const languageHtml = languages.length
            ? `<p style="text-align:left">The editor also needs the language on their profile. Add it in User Management:</p>` +
              `<ul style="text-align:left">${languageList}</ul>`
            : '';
        const result = await Swal.fire({
            title: needed.length ? 'Give edit access?' : 'Language not on their profile',
            html: accessHtml + languageHtml,
            ...(needed.length
                ? {
                      input: 'checkbox',
                      inputValue: 0,
                      inputPlaceholder: 'Give them edit access to the folder',
                      inputValidator: (checked) => (!checked ? 'Tick the box to give access, or cancel' : undefined),
                  }
                : {}),
            showCancelButton: true,
            confirmButtonText: 'Assign',
        });
        if (!result.isConfirmed) {
            return null;
        }
        return request(true);
    }
};
